import { useQuery } from '@tanstack/react-query'

import { getIssuableStatus } from '@src/api'
import { DefaultApiGetIssuableStatusRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchIssuableStatus = (
  params: DefaultApiGetIssuableStatusRequest
) => {
  const { axiosInstance } = useAxios()

  return useQuery({
    enabled: !!params.organizationId,
    queryFn: () => getIssuableStatus(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_ISSUABLE_STATUS],
  })
}
